import { render, staticRenderFns } from "./ArticleldReport.vue?vue&type=template&id=50f8da34&scoped=true&"
import script from "./ArticleldReport.vue?vue&type=script&lang=js&"
export * from "./ArticleldReport.vue?vue&type=script&lang=js&"
import style0 from "./ArticleldReport.vue?vue&type=style&index=0&id=50f8da34&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8da34",
  null
  
)

export default component.exports